import React from "react";

class CurrencyList {
    static register = {
        "CHF": {slug: "CHF", Name: "Swiss Franc"},
        "CZK": {slug: "CZK", Name: "Czech Krona"},
        "DKK": {slug: "DKK", Name: "Danish Krone"},
        "EUR": {slug: "EUR", Name: "Euro"},
        "GBP": {slug: "GBP", Name: "British Pound"},
        "HKD": {slug: "HKD", Name: "Hong Kong Dollar"},
        "ILS": {slug: "ILS", Name: "Israeli Shekel"},
        "JPY": {slug: "JPY", Name: "Japanese Yen"},
        "NOK": {slug: "NOK", Name: "Norwegian Krone"},
        "PLN": {slug: "PLN", Name: "Polish Zloty (new)"},
        "RON": {slug: "RON", Name: "New Romanian Leu"},
        "SEK": {slug: "SEK", Name: "Swedish Krona"},
        "TRY": {slug: "TRY", Name: "Turkish Lira"},
        "USD": {slug: "USD", Name: "American Dollar"},
        "ZAR": {slug: "ZAR", Name: "South African Rand"}
        // "AED": {slug: "AED", Name: "United Arab Emirates Dirham"},
        // "AUD": {slug: "AUD", Name: "Australian Dollar"},
        // "BRL": {slug: "BRL", Name: "Brazilian Real"},
        // "CAD": {slug: "CAD", Name: "Canadian Dollar"},
        // "CNY": {slug: "CNY", Name: "Chinese Renmimbi"},
        // "EEK": {slug: "EEK", Name: "Estonian Krone"},
        // "HRK": {slug: "HRK", Name: "Croatian Kuna"},
        // "HUF": {slug: "HUF", Name: "Hungarian Forint"},
        // "INR": {slug: "INR", Name: "Indian Rupee"},
        // "KRW": {slug: "KRW", Name: "South Korean Won"},
        // "LVL": {slug: "LVL", Name: "Latvian Lat"},
        // "MXN": {slug: "MXN", Name: "Mexican Peso"},
        // "MYR": {slug: "MYR", Name: "Malaysian Ringgit"},
        // "NZD": {slug: "NZD", Name: "New Zealand Dollars"},
        // "RSD": {slug: "RSD", Name: "Serbian Dinar"},
        // "RUB": {slug: "RUB", Name: "Russian Rouble (new as of 01.01.98)"},
        // "SGD": {slug: "SGD", Name: "Singapore Dollar"},
        // "THB": {slug: "THB", Name: "Thailand Bhat"},
        // "TWD": {slug: "TWD", Name: "New Taiwan Dollar"},
        // "UAH": {slug: "UAH", Name: "Ukraine Hryvnia"},
    };
}

export default CurrencyList;